import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { TagGroupModel } from "../models/TagGroupModel";
import { OptionTag } from "../models/OptionTagModel";
import { TagFilter } from "../models/TagFilter";

@Injectable({
  providedIn: "root"
})
export class OptionTagsService {
  constructor(private http: HttpClient) { }

  getOptionTags() {
    return this.http.get<OptionTag[]>(`${environment.api}/api/optionTags/allOptionsTag`);
  }

  getTagGroups() {
    return this.http.get<TagGroupModel[]>(`${environment.api}/api/TagGroups`);
  }

  refreshOptionTags() {
    return this.http.get(`${environment.api}/api/optionTags/`);
  }

  getTagFilters(refresh: boolean) {
    return this.http.get<TagFilter[]>(`${environment.api}/api/TagFilters?refresh=${refresh}`);
  }
}
